import axios from "@lib/axios";

export async function getHub(slug, locale) {
  const response = await axios.get(`hubs/${slug}`,{
    headers: { Language: locale },
  });

  return response.data;
}
